export const baseURL = "https://thekrish.in/api/cryptographyapi/";
